export default {
	verifying: "Verificando...",
	success: "¡Correo Verificado!",
	successDesc: "Su cuenta ha sido activada con éxito. Ya puede iniciar sesión.",
	goToLogin: "Ir al Login",
	checkEmail: "Verifique su Correo",
	sentTo: "Hemos enviado un enlace de verificación a {email}",
	checkSpam: "¿No lo encuentra? Revise la carpeta de spam.",
	resend: "Reenviar Correo",
	resendSuccess: "¡Correo reenviado con éxito!",
	error: "Error en la Verificación",
	invalidToken: "Token inválido o caducado. Solicite uno nuevo.",
};
